module.exports = __webpack_public_path__ + "img/header_slotmachine_freespin._no_fg.4d91b57b.png";